import styled from 'styled-components';

export const StyledEventPreviewLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  min-height: 0;
`;

export const StyledEventPreviewScroll = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const StyledEventPreviewFooter = styled.div`
  flex: 0 0 auto;
  padding-top: 8px;
  padding-bottom: var(--ion-safe-area-bottom, 0px);
  background: #FFFFFF;
`;

export const StyledAcceptedBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #0f9d58 0%, #34a853 35%, #66bb6a 100%);
  border: 1px solid rgba(52, 168, 83, 0.6);
  box-shadow: 0 4px 12px rgba(52, 168, 83, 0.25);
  color: #FFFFFF;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;

  ion-icon {
    flex: 0 0 auto;
    font-size: 18px;
  }
`;
